<template>
  <v-data-table
    mobile-breakpoint="0"
    :items-per-page="-1"
    item-key="id"
    :headers="headers"
    :items="sortPeriods"
    v-bind="this.$attrs"
    hide-default-footer
    loading-text="Đang Tải"
    :loading="loading"
    disable-sort
  >
    <template v-slot:no-data>
      <div class="my-14 font-weight-bold">
        <div>Hiện tại chưa có kỳ thu/đóng trong danh sách.</div>
      </div>
    </template>
    <template v-slot:[`item.title`]="{ item }">
      <router-link :to="'/salary-period/' + item.id" style="text-decoration: none">
        {{ item.title | convertFullDate }}
      </router-link>
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <v-chip small class="white--text" v-if="item.status" :color="getStatus(item.status).color" label>
        <span class="white--text">{{ getStatus(item.status).status }}</span>
      </v-chip>
    </template>
    <template v-slot:[`item.last`]="{ item }">
      <span v-if="item.status === 'finished' || item.status === 'running'">
        {{ item.updatedAt | ddmmyyyy }}, lúc {{ item.updatedAt | hhmm }}
      </span>
    </template>
    <template v-slot:[`item.person`]="{ item }">
      <router-link class="text-decoration-none" :to="getLink(item.generatedBy)">
        {{ get(item, 'generatedBy.name') }}
      </router-link>
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <v-btn icon @click="() => showDetailPeriod(item.id)">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>
<script>
import { mapGetters } from 'vuex'
import { get } from 'lodash'
const originHeaders = [
  { text: 'Kỳ đóng', value: 'title', width: '20%' },
  { text: 'Trạng thái', value: 'status', width: '20%' },
  { text: 'Tổng kết lần cuối', value: 'last', width: '20%' },
  { text: 'Người thực hiện', value: 'person', width: '20%' },
  { text: 'Thao tác', value: 'action', align: 'center', width: '10%' }
]
export default {
  data() {
    return {
      headers: Array.isArray(this.propHeaders) && this.propHeaders.length ? this.propHeaders : originHeaders,
      originHeaders: originHeaders,
      selected: [],
      groupTableOptions: {},
      get
    }
  },
  computed: {
    ...mapGetters({
      periods: 'salaryPeriod/periods',
      loading: 'salaryPeriod/loading'
    }),
    sortPeriods() {
      return this.$utils.sortPeriod(this.periods)
    }
  },
  methods: {
    getStatus(status) {
      switch (status) {
        case 'created':
          return { color: '#D3D3D3', status: 'Chưa tổng kết' }
        case 'running':
          return { color: '#F4BB43', status: 'Đang tổng kết' }
        case 'finished':
          return { color: '#46BE8A', status: 'Đã tổng kết' }
      }
    },
    getLink(person) {
      if (person && person.id) return `/staff/${person.id}`
      return '#'
    },
    showDetailPeriod(id) {
      this.$router.push({ path: `salary-period/${id}` })
    }
  }
}
</script>
<style scoped>
.nowrap {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: 230px;
}
</style>
